// The round sign a seans wears on the grid and in the danışman drawer:
// the drawer's status chip as an icon. Planlı is an empty ring —
// nothing to say yet.

import type {SeansStateKind} from "../labels";
import type {IconName} from "../ui/Icon";

export const STATE_SIGN: Record<SeansStateKind, IconName | null> = {
  planned: null, confirmed: "check", declined: "x", unrecorded: "bang", partial: "bang",
  done: "check", cancelled: "x", paused: "pause",
};
